import React from "react";
import Bank2 from "./Assets/Bank2.png.jpeg";
import bank4 from "./Assets/bank4.png.jpeg";
import bus4 from "./Assets/bus4.png.jpeg";
import hotel2 from "./Assets/hotel2.png.jpeg";
import hotel3 from "./Assets/hotel3.png.jpeg";
import market3 from "./Assets/market3.png.jpeg";
import market5 from "./Assets/market5.png.jpeg";
import market6 from "./Assets/market6.png.jpeg";
import "./About.css"
export default function About() {
    const sections = [
        {
          text: "Want to elevate your banking business? Join us to make banking better and more sustainable.",
          images: [bank4, Bank2],
        },
        {
          text: "Want to elevate your hotel business? Join us to make hotel management better and more sustainable.",
          images: [hotel2, hotel3],
        },
        {
          text: "Want to elevate your business? Join us to make it better and more sustainable.",
          images: [market3, market5],
        },
        {
          text: "Want to elevate your transporter business? Join us to make transport management better and more sustainable.",
          images: [bus4, market6],
        },
      ];
    return (
        <div className=" max-w-full min-w-fit">
            <div className="bg-gray-100 items-center mt-5 p-4">
                <p className="text-gray-700 font-semibold underline">Our Mission</p>
                <h4 className="flex flex-auto">
                   We are here to empower you with the right tools to upscale your businesses
                   <br/>
                   and help take it to the next level with endless optimization and enhanced user experience
                </h4>
                <p className="text-blue-500 font-semibold underline capitalize">Our Vision</p>
                <h4>
                  We are here to use Technology to empower business
                   <br/>
                  with an endless optimization and endless inclusion your business will srive within a few  days
                </h4>
            </div> 
           {/* Sections */}
           <div className="p-6">
        {sections.map((item, index) => (
          <div
            key={index}
            className="grid gap-4 items-center lg:gap-6 mb-8"
          >
            {/* Text */}
            <div className="text-gray-700 font-medium text-center lg:text-left">
              {item.text}
            </div>

            {/* Images */}
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-1 lg:grid-cols-2">
              {item.images.map((image, imgIndex) => (
                <img
                  key={imgIndex}
                  src={image}
                  alt={`Image ${imgIndex + 1}`}
                  className="w-full max-h-72 min-h-20 object-cover rounded-lg "
                />
              ))}
            </div>
          </div>
        ))}
      </div>

            <footer className="bg-blue-300 flex flex-col items-center text-white p-4">
                <p>Virtual-business-app all rights reserved</p>
            </footer>
        </div>
    );
}
